export default __webpack_public_path__ + "static/product-diary-protectors-c1749a2fe20e18c41ae13eeda34d0b2a.png";